import script from "./EditSubObject.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSubObject.vue?vue&type=script&setup=true&lang=js"

import "./EditSubObject.vue?vue&type=style&index=0&id=aeb07c4a&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeb07c4a"]])

export default __exports__